import React, { FC } from 'react';

import { IButtons, IButtonVerticalItem } from '../../../common/messageCreators';
import { useIsSmallScreen, useUserActionClickButton } from '../../hooks';
import { MessageItem } from '../MessageItem';
import { ButtonsDefault } from './ButtonsDefault';
import { ButtonsVertical } from './ButtonsVertical';
import { useCanUseDefaultButtons } from './useCanUseDefaultButtons';

export const Buttons: FC<IButtons> = ({ id, type, items }) => {
  const emit = useUserActionClickButton();
  const isDefault = useCanUseDefaultButtons(type, items);
  const isSmallScreen = useIsSmallScreen();

  const onClick = (btn: IButtonVerticalItem, position: number) => {
    emit({ ...btn, position });
  };

  const buttons = isDefault ? (
    <ButtonsDefault items={items} onClick={onClick} />
  ) : (
    <ButtonsVertical items={items} onClick={onClick} />
  );

  return (
    <MessageItem id={id} width={isSmallScreen && isDefault ? 'full' : 'fit-content'}>
      {buttons}
    </MessageItem>
  );
};
